<template>
  <div>
    <h2 v-if="title">{{ title }}</h2>
    <b-card no-body class="mb-5" border-variant="grey-mid">
      <b-tabs card vertical end>
        <b-tab tag='h2' title="View:" disabled></b-tab>
        <b-tab title="Table" active>
          <b-card-body>
            <b-container>
              <b-row>
                <b-col v-for="table, index in tables" :lg="size && size == 'half' ? 6 : 12" :key="index">
                  <mio-table :data-filter="table.title" :data="table" />
                </b-col>
              </b-row>
            </b-container>
          </b-card-body>
        </b-tab>
        <b-tab v-if="messages" title="Log">
          <b-card-body>
            <b-container>
              <b-row>
                <b-col>
                  <b-list-group>
                    <b-list-group-item v-for="message in messages" class="text-monospace" :key="message">{{ message }}</b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-container>
          </b-card-body>
        </b-tab>
      </b-tabs>
      <b-card-footer v-if="method" footer-border-variant="grey-mid">
        <div class="text-monospace small text-muted">
          <strong>Method:</strong> {{ method }}
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import MioTable from './MioTable';

export default {
  name: 'MioOutput',
  components: {
    MioTable
  },
  props: {
    title: String,
    tables: Array,
    messages: Array,
    method: String,
    size: String,
  },
}
</script>
